import React from 'react';
import { Wallet, WalletType } from '../../types';
import './WalletCard.css';

interface WalletCardProps {
  wallet: Wallet;
  onClick?: () => void;
}

export const WalletCard: React.FC<WalletCardProps> = ({ wallet, onClick }) => {
  const getWalletColor = (type: WalletType) => {
    switch (type) {
      case WalletType.MAIN:
        return 'main';
      case WalletType.GRANT:
        return 'grant';
      case WalletType.REWARDS:
        return 'rewards';
      default:
        return 'main';
    }
  };

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-ZA', {
      style: 'currency',
      currency: wallet.currency,
      minimumFractionDigits: 2,
    }).format(amount);
  };

  return (
    <div 
      className={`wallet-card wallet-${getWalletColor(wallet.type)}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <div className="wallet-header">
        <div className="wallet-type">{wallet.type}</div>
      </div>
      
      <div className="wallet-balances">
        <div className="balance-row">
          <div className="balance-label">Total Balance</div>
          <div className="balance-amount total">{formatCurrency(wallet.totalBalance)}</div>
        </div>
        <div className="balance-row">
          <div className="balance-label">Available Balance</div>
          <div className="balance-amount available">{formatCurrency(wallet.availableBalance)}</div>
        </div>
        {wallet.reservedAmount > 0 && (
          <div className="reserved-amount">
            <span className="reserved-label">Reserved for orders:</span>
            <span className="reserved-value">{formatCurrency(wallet.reservedAmount)}</span>
          </div>
        )}
      </div>
      
      {wallet.isActive && (
        <div className="wallet-status">
          <span className="status-dot"></span>
          Active
        </div>
      )}
    </div>
  );
};